var map = {
	"./ar/label.json": 33549,
	"./cy/label.json": 95685,
	"./cz/label.json": 79608,
	"./da/label.json": 80213,
	"./de/label.json": 85498,
	"./en/label.json": 34028,
	"./es/label.json": 68459,
	"./fi/label.json": 91855,
	"./fr/label.json": 10541,
	"./hu/label.json": 58647,
	"./it/label.json": 21010,
	"./ja/label.json": 27078,
	"./ko/label.json": 10845,
	"./kz/label.json": 81864,
	"./nl/label.json": 69127,
	"./pl/label.json": 46256,
	"./pt/label.json": 43538,
	"./ro/label.json": 32678,
	"./ru/label.json": 25513,
	"./sk/label.json": 65764,
	"./sv/label.json": 3534,
	"./vn/label.json": 39247
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64352;